// extracted by mini-css-extract-plugin
module.exports = {"name":"_ZHY9c","shareButton":"YfJ8Yt"};